import React, { useContext, useEffect, useRef, useState } from "react";
import ComponentContainer from "./componentContainer";
import Util from "../util/util";
import { Alert, Autocomplete, Box, Button, Checkbox, Divider, FormControl, FormControlLabel, Grid, IconButton, List, ListItem, ListItemText, Menu, MenuItem, Modal, Paper, TextField, Tooltip, Typography } from "@mui/material";
import MailLockIcon from '@mui/icons-material/MailLock';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SearchIcon from '@mui/icons-material/Search';
import ErrorIcon from '@mui/icons-material/Error';
import dateFormat, { masks } from "dateformat";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { hr } from "date-fns/locale";
import DateFnsUtils from "@date-io/date-fns";
import api from "../util/api";
import globalContext from "./globalContext";
import AlertDialog from "./alertdialog";
import ERacunListItem from "./eRacunListItem";
import LibraryAddCheckIcon from '@mui/icons-material/LibraryAddCheck';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import SendIcon from '@mui/icons-material/Send';
import CancelIcon from '@mui/icons-material/Cancel';
import SyncIcon from '@mui/icons-material/Sync';
import AutoFixNormalIcon from '@mui/icons-material/AutoFixNormal';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import EditCalendarIcon from '@mui/icons-material/EditCalendar';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import ReportIcon from '@mui/icons-material/Report';
import BugReportIcon from '@mui/icons-material/BugReport';
import TocIcon from '@mui/icons-material/Toc';
import DifferenceIcon from '@mui/icons-material/Difference';
import EditIcon from "@mui/icons-material/Edit";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const racuniTypes = [
    { RacuniTypeID: 0, Name: "računi za slanje" },
    { RacuniTypeID: 3, Name: "računi u procesu slanja" },
    { RacuniTypeID: 1, Name: "poslani neplaćeni i djelomično plaćeni računi" },
    { RacuniTypeID: 2, Name: "poslani završeni računi" }
]

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'white',
    border: '2px solid #000',
    p: 6
};

export default function ERacuni(props) {

    const useConstructor = Util.useConstructor();

    const global = useContext(globalContext);

    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const filterOpened = Boolean(anchorEl);
    const [filterLabel, setFilterLabel] = useState("");
    const [pocetak, setPocetak] = useState(null);
    const [kraj, setKraj] = useState(null);
    const [racuniType, setRacuniType] = useState(null);
    const [filterInitialized, setFilterInitialized] = useState(false);
    const [filterHistory, setFilterHistory] = useState(null);
    const [racuni, setRacuni] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [oznaceniRacuniIDs, setOznaceniRacuniIDs] = useState([]);
    const [grupa, setGrupa] = useState(null);
    const [confirmMessage, setConfirmMessage] = useState(null);
    const [confirmTitle, setConfirmTitle] = useState("");
    const [confirmAction, setConfirmAction] = useState("");
    const [datumSlanja, setDatumSlanja] = useState(null);
    const [placeno, setPlaceno] = useState(0);
    const [datumPlacanja, setDatumPlacanja] = useState(null);
    const [posaljiPrilog, setPosaljiPrilog] = useState(null);
    const [naciniPlacanja, setNaciniPlacanja] = useState([]);
    const [nacinPlacanja, setNacinPlacanja] = useState(null);
    const [posaljiPrilogSpecifikaciju, setPosaljiPrilogSpecifikaciju] = useState(false);
    const [placanja, setPlacanja] = useState([]);
    const [placanjaOpen, setPlacanjaOpen] = useState(false);
    const [kopijaOpen, setKopijaOpen] = useState(false);
    const [napomena, setNapomena] = useState("");
    const [poslovniProcesi, setPoslovniProcesi] = useState([]);
    const [poslovniProces, setPoslovniProces] = useState(null);
    const [poslovniProcesOznakaKupca, setPoslovniProcesOznakaKupca] = useState("");
    const [ugovorReferenca, setUgovorReferenca] = useState("");
    const [narudzbenicaReferenca, setNarudzbenicaReferenca] = useState("");

    const ref = useRef(0);

    useConstructor(() => {
        dohvatiFilter();
    });

    function dohvatiFilter() {
        setLoading(true);

        api.get("eracuni/dohvatiFilter?korisnikID=" + global.user.korisnikID, dohvatiFilterSuccess, fail);
    }

    function dohvatiFilterSuccess(data) {
        setPocetak(data.Pocetak);
        setKraj(data.Kraj);
        setPosaljiPrilog(data.PosaljiPrilog);
        setPosaljiPrilogSpecifikaciju(data.PosaljiPrilogSpecifikaciju);
        setRacuniType(racuniTypes.find(t => t.RacuniTypeID == data.TipRacuna));
        setNaciniPlacanja(data.NaciniPlacanja);
    }

    useEffect(() => {
        if (!filterInitialized && pocetak && kraj && posaljiPrilog != null && racuniType) {
            setFilterInitialized(true);

            loadRacuni();
        }
    }, [pocetak, kraj, racuniType, posaljiPrilog, filterInitialized]);

    function loadRacuni() {
        setLoading(true);

        setFilterLabel("Odabrani filter: " + racuniType.Name + " izdani između " + dateFormat(pocetak, "dd.mm.yyyy.") + " i " + dateFormat(kraj, "dd.mm.yyyy."));

        setFilterHistory({
            Pocetak: pocetak,
            Kraj: kraj,
            RacuniType: racuniType
        });

        let args = {
            KorisnikID: global.user.korisnikID,
            Pocetak: pocetak,
            Kraj: kraj,
            TipRacuna: racuniType.RacuniTypeID
        };
        api.post("eracuni/dohvati", args, loadRacuniSuccess, fail);
    }

    function loadRacuniSuccess(data) {
        setRacuni(data);
        setOznaceniRacuniIDs(data.map(r => r.RacunID));
        setGrupa(racuniType.RacuniTypeID);

        setAnchorEl(false);
        setLoading(false);
    }

    function fail(data) {
        setErrorMessage(data ? (data.Message || data.toString()) : "");
        setLoading(false);
    }

    function handleFilterClick(event) {
        setAnchorEl(event.currentTarget);
    };

    function handleFilterClose() {
        if (filterHistory) {
            setPocetak(filterHistory.Pocetak);
            setKraj(filterHistory.Kraj);
            setRacuniType(filterHistory.RacuniType);
        }
        setAnchorEl(null);
    };

    function onRacunClick(event, racunID, indexRacuna, lastIndexRacuna) {
        if (event.ctrlKey && !event.shiftKey) {
            if (oznaceniRacuniIDs.includes(racunID)) {
                setOznaceniRacuniIDs(oldOznaceni => oldOznaceni.filter(id => id !== racunID));
            } else {
                setOznaceniRacuniIDs(oldOznaceni => [...oldOznaceni, racunID]);
            }
        } else if (event.shiftKey && !event.ctrlKey) {
            if (window.getSelection) {
                if (window.getSelection().empty) {  // Chrome
                  window.getSelection().empty();
                } else if (window.getSelection().removeAllRanges) {  // Firefox
                  window.getSelection().removeAllRanges();
                }
            } else if (document.selection) {  // IE?
                document.selection.empty();
            }
            let newOznaceni = [];
            if (indexRacuna > lastIndexRacuna) {
                for (let i = lastIndexRacuna; i <= indexRacuna; i++) {
                    newOznaceni.push(racuni.at(i).RacunID);
                }
            } else {
                for (let i = lastIndexRacuna; i >= indexRacuna; i--) {
                    newOznaceni.push(racuni.at(i).RacunID);
                }
            }
            setOznaceniRacuniIDs(newOznaceni);
        } else if (!event.shiftKey && !event.ctrlKey) {
            let newOznaceni = [];
            newOznaceni.push(racunID);
            setOznaceniRacuniIDs(newOznaceni);
        }
        ref.current = indexRacuna;
    };

    function oznaciSve() {
        setOznaceniRacuniIDs(racuni.map(r => r.RacunID));
    }

    function ponistiOdabir() {
        setOznaceniRacuniIDs([]);
    }

    function posalji() {
        setConfirmTitle("Slanje e-računa");
        setConfirmMessage(<div>Jeste li sigurni da želite poslati račun/e <b>{racuni.filter(r => oznaceniRacuniIDs.includes(r.RacunID)).map(r => r.Broj).sort().join(", ")}</b>?</div>);
        setConfirmAction("posalji");
    }

    function posaljiConfirmed() {
        setLoading(true);
        let data = {
            RacuniIDs: oznaceniRacuniIDs,
            PosaljiPrilog: posaljiPrilog,
            KorisnikID: global.user.korisnikID,
            PosaljiPrilogSpecifikaciju: posaljiPrilogSpecifikaciju
        };
        api.post("eracuni/posalji", data, confirmSuccess, fail);
    }

    function zakaziSlanje() {
        setConfirmTitle("Zakazivanje slanja e-računa");
        setDatumSlanja(null);
        setConfirmMessage(<div>Odaberite datum i vrijeme slanja računa <b>{racuni.filter(r => oznaceniRacuniIDs.includes(r.RacunID)).map(r => r.Broj).sort().join(", ")}</b>.</div>);
        setConfirmAction("zakaziSlanje");
    }

    function zakaziSlanjeConfirmed() {
        setLoading(true);
        let data = {
            RacuniIDs: oznaceniRacuniIDs,
            DatumSlanja: datumSlanja,
            PosaljiPrilog: posaljiPrilog,
            KorisnikID: global.user.korisnikID,
            PosaljiPrilogSpecifikaciju: posaljiPrilogSpecifikaciju
        };
        api.post("eracuni/zakazislanje", data, confirmSuccess, fail);
    }

    function obrisiGresku() {
        setConfirmTitle("Brisanje greške slanja prema posredniku");
        setConfirmMessage(<div>Jeste li sigurni da želite obrisati grešku/e slanja prema posredniku za račun/e <b>{racuni.filter(r => oznaceniRacuniIDs.includes(r.RacunID)).map(r => r.Broj).sort().join(", ")}</b> i time omogućiti radnju ponovnog slanja?</div>);
        setConfirmAction("obrisiGresku");
    }

    function obrisiGreskuConfirmed() {
        setLoading(true);
        api.post("eracuni/obrisikrajnjugresku", oznaceniRacuniIDs, confirmSuccess, fail);
    }

    function confirmSuccess() {
        closeConfirmWindow();
        loadRacuni();
    }

    function azurirajStatuse() {
        setLoading();
        api.post("eracuni/azurirajstatuse", oznaceniRacuniIDs, loadRacuni, fail);
    }

    function ponistiSlanje() {
        setConfirmTitle("Poništavanje slanja e-računa");
        setConfirmMessage(<div>Jeste li sigurni da želite poništiti slanje računa <b>{racuni.filter(r => oznaceniRacuniIDs.includes(r.RacunID)).map(r => r.Broj).sort().join(", ")}</b>?</div>);
        setConfirmAction("ponistiSlanje");
    }

    function ponistiSlanjeConfirmed() {
        setLoading(true);
        api.post("eracuni/ponistislanje", oznaceniRacuniIDs, ponistiSlanjeSuccess, fail);
    }

    function ponistiSlanjeSuccess(data) {
        setLoading(false);
        closeConfirmWindow();
        if (data && data.length > 0) {
            setErrorMessage(<div>Slanje računa <b>{data.join(", ")}</b> nije poništeno.</div>);
        } else {
            loadRacuni();
        }
    }

    function oznaciKaoPlacen() {
        setConfirmTitle("Označavanje e-računa kao plaćenog");
        setPlaceno(0);
        setDatumPlacanja(null);
        let racun = racuni.find(r => r.RacunID == oznaceniRacuniIDs[0]);
        setNacinPlacanja(naciniPlacanja.find(np => np.NacinPlacanjaID == racun.NacinPlacanjaID));
        setConfirmMessage(<div>Upišite iznos koji je uplaćen za račun <b>{racun.Broj}</b> (ukupni iznos računa: {racun.Iznos.toLocaleString("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}), datum i način plaćanja.</div>);
        setConfirmAction("oznaciKaoPlacen");
    }

    function oznaciKaoPlacenConfirmed() {
        setLoading(true);
        let data = {
            RacunID: oznaceniRacuniIDs[0],
            Placeno: parseFloat(placeno),
            DatumPlacanja: datumPlacanja,
            FiskalniNacinPlacanjaKod: nacinPlacanja.FiskalniNacinPlacanja.ERacunKod
        };
        api.post("eracuni/oznacikaoplacen", data, confirmSuccess, fail);
    }

    function closeConfirmWindow() {
        setConfirmTitle("");
        setConfirmMessage(null);
        setConfirmAction("");
    }

    function onConfirm() {
        switch (confirmAction) {
            case "obrisiGresku":
                obrisiGreskuConfirmed();
                break;
            case "ponistiSlanje":
                ponistiSlanjeConfirmed();
                break;
            case "posalji":
                posaljiConfirmed();
                break;
            case "zakaziSlanje":
                zakaziSlanjeConfirmed();
                break;
            case "oznaciKaoPlacen":
                oznaciKaoPlacenConfirmed();
                break;
            case "eIzvjestavanje":
                eIzvjestavanjeConfirmed();
                break;
        }
    }

    function closeErrorAlert() {
        setErrorMessage("");
        loadRacuni();
    }

    function handlePlacenoChange(e) {
        let v = e.target.value.replace(",", ".");

        let numOfDots = [...v].reduce((num, char) => char === "." ? num + 1 : num, 0);

        if (numOfDots == 2) {
            v = v.replace(".", "");
        }

        if (v == "" || v == "-" || /^-?\d+(\.\d{0,2})?$/.test(v)) {
            setPlaceno(v);
        }
    }

    function handlePlacenoFocusOut() {
        if (placeno == "" || isNaN(parseFloat(placeno))) {
            setPlaceno(0);
        } else {
            setPlaceno(parseFloat(placeno));
        }
    }

    function eIzvjestavanje() {
        setConfirmTitle("Slanje računa na e-Izvještavanje");
        setConfirmMessage(
            <div>
                <Alert severity="warning">
                    <b>UPOZORENJE!</b>
                    <br></br>
                    Ova operacija treba se pozivati isključivo za račune izdane kupcima koji nisu registrirani u AMS sustav i kao takvi ne mogu primiti e-Račun.
                </Alert>
                <br></br>
                Jeste li sigurni da želite poslati račun <b>{racuni.find(r => r.RacunID == oznaceniRacuniIDs).Broj}</b> na e-Izvještavanje?
            </div>
        );
        setConfirmAction("eIzvjestavanje");
    }

    function eIzvjestavanjeConfirmed() {
        setLoading(true);
        let data = {
            RacunID: oznaceniRacuniIDs[0],
            KorisnikID: global.user.korisnikID,
        };
        api.post("eracuni/eizvjestavanje", data, confirmSuccess, fail);
    }

    function testXML() {
        setLoading(true);
        let data = {
            RacuniIDs: oznaceniRacuniIDs,
            PosaljiPrilog: true,
            KorisnikID: global.user.korisnikID,
            PosaljiPrilogSpecifikaciju: false
        };
        api.post("eracuni/testirajxml", data, confirmSuccess, fail);
    }

    function pregledPlacanja() {
        setLoading(true);
        api.get("eracuni/pregledplacanja?racunID=" + oznaceniRacuniIDs[0], pregledPlacanjaSuccess, fail);
    }

    function pregledPlacanjaSuccess(data) {
        setPlacanja(data);
        setPlacanjaOpen(true);
        debugger;
        setLoading(false);
    }

    function kopija() {
        setLoading(true);
        let data = {
            RacunID: oznaceniRacuniIDs[0],
            Napomena: napomena,
            ErPoslovniProcesID: poslovniProces.ErPoslovniProcesID,
            ErPoslovniProcesOznakaKupca: poslovniProcesOznakaKupca,
            ErUgovorReferenca: ugovorReferenca,
            ErNarudzbenicaReferenca: narudzbenicaReferenca
        };
        api.post("eracuni/kopija", data, kopijaSuccess, fail);
    }

    function kopijaSuccess() {
        closeKopija(false);
        loadRacuni();
    }

    function loadKopija() {
        setLoading(true);
        api.get("eracuni/getkopijadetalji?racunID=" + oznaceniRacuniIDs[0], loadKopijaSuccess, fail);
    }

    function loadKopijaSuccess(data) {
        setNapomena(data.Napomena);
        setPoslovniProcesi(data.PoslovniProcesi);
        setPoslovniProces(data.PoslovniProcesi.find(pp => pp.ErPoslovniProcesID == data.ErPoslovniProcesID));
        setPoslovniProcesOznakaKupca(data.ErPoslovniProcesOznakaKupca);
        setUgovorReferenca(data.ErUgovorReferenca);
        setNarudzbenicaReferenca(data.ErNarudzbenicaReferenca);
        setKopijaOpen(true);
        setLoading(false);
    }

    function closeKopija() {
        setNapomena("");
        setPoslovniProcesi([]);
        setPoslovniProces(null);
        setPoslovniProcesOznakaKupca("");
        setUgovorReferenca("");
        setNarudzbenicaReferenca("");
        setKopijaOpen(false);
    }

    return (
        <ComponentContainer loading={loading}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Typography variant="h4" gutterBottom component="div" style={{marginBottom:"15px"}}>
                        <MailLockIcon fontSize="medium" style={{marginRight:"15px"}}></MailLockIcon>
                        e-Računi
                    </Typography>
                </Grid>
                <Grid item xs={7}>
                    <div>{filterLabel}</div>
                </Grid>
                <Grid item xs={5} container justifyContent="flex-end">
                    <Button startIcon={<SyncIcon></SyncIcon>} onClick={loadRacuni} variant="outlined" style={{marginRight:"5px", marginBottom:"5px"}} color="success" disabled={filterOpened || !pocetak || !kraj || !racuniType}>Osvježi</Button>           
                    <Button
                        id="basic-button"
                        aria-controls={filterOpened ? 'basic-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={filterOpened ? 'true' : undefined}
                        onClick={handleFilterClick}
                        size="medium"
                        style={{marginBottom:"5px"}}
                        variant="outlined"
                        endIcon={filterOpened ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    >
                        Filter
                    </Button>
                    <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={filterOpened}
                        onClose={handleFilterClose}
                        MenuListProps={{
                            'aria-labelledby': 'basic-button',
                        }}
                    >
                        <FormControl fullWidth>
                            <MenuItem>
                                <Autocomplete 
                                    style={{width:"100%"}}
                                    options={racuniTypes}
                                    getOptionLabel={(option) => option.Name}
                                    value={racuniType}
                                    onChange={(e,v) => {if (v) setRacuniType(v)}}
                                    disableClearable
                                    renderInput={(params) => <TextField {...params} label="Stanje" size="small"/>}
                                />
                            </MenuItem>
                        </FormControl>
                        <MenuItem>
                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                                <DatePicker
                                    label="od"
                                    value={pocetak}
                                    inputFormat="dd.MM.yyyy"
                                    onChange={(v) => setPocetak(v)}
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                />
                            </LocalizationProvider>
                        </MenuItem>
                        <MenuItem>
                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={hr} utils={DateFnsUtils} fullWidth>
                                <DatePicker
                                    label="do"
                                    value={kraj}
                                    inputFormat="dd.MM.yyyy"
                                    onChange={(v) => setKraj(v)}
                                    renderInput={(params) => <TextField {...params} size="small" />}
                                />
                            </LocalizationProvider>
                        </MenuItem>
                        <Divider></Divider>
                        <div style={{textAlign:"center"}}><Button variant="outlined" color="success" startIcon={<SearchIcon></SearchIcon>} onClick={loadRacuni} disabled={!pocetak || !kraj || !racuniType}>Dohvati</Button></div>
                    </Menu>
                </Grid>
                {grupa != null && racuni.length != 0 ? (
                    <Grid item xs={12}>
                        <ListItem className="list-title" key="racuni-title" style={{backgroundColor:"lightblue"}}>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Tooltip title="Broj" enterDelay={200} enterNextDelay={200}>
                                        <ListItemText style={{ paddingLeft:"5px" }} primaryTypographyProps={{ noWrap:true }} primary="Broj" />
                                    </Tooltip>
                                </Grid>
                                {grupa == 0 ? (
                                    <Grid item xs={2}>
                                        <Tooltip title="Datum" enterDelay={200} enterNextDelay={200}>
                                            <ListItemText style={{ paddingLeft:"15px" }} primaryTypographyProps={{ noWrap:true }} primary="Datum" />
                                        </Tooltip>
                                    </Grid>
                                ) : null}
                                <Grid item xs={1}>
                                    <Tooltip title="Iznos" enterDelay={200} enterNextDelay={200}>
                                        <ListItemText style={{ paddingLeft:"5px", textAlign:"right" }} primaryTypographyProps={{ noWrap:true }} primary="Iznos" />
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={3}>
                                    <Tooltip title="Klijent" enterDelay={200} enterNextDelay={200}>
                                        <ListItemText style={{ paddingLeft:"15px" }} primaryTypographyProps={{ noWrap:true }} primary="Klijent" />
                                    </Tooltip>
                                </Grid>
                                <Grid item xs={5}>
                                    <Tooltip title="Status" enterDelay={200} enterNextDelay={200}>
                                        <ListItemText style={{ paddingLeft:"15px" }} primaryTypographyProps={{ noWrap:true }} primary="Status" />
                                    </Tooltip>
                                </Grid>
                                {grupa == 3 ? (
                                    <Grid item xs={2}>
                                        <Tooltip title="Vrijeme slanja" enterDelay={200} enterNextDelay={200}>
                                            <ListItemText style={{ paddingLeft:"15px" }} primaryTypographyProps={{ noWrap:true, fontWeight:props.fontWeight }} primary="Vrijeme slanja" />
                                        </Tooltip>
                                    </Grid>
                                ) : null}
                            </Grid>
                        </ListItem>
                        <Paper variant="outlined" style={{width:"100%", maxHeight: 350, overflow: 'auto'}}>
                            <List dense>
                                {racuni.map((r,i) => {
                                    return <ERacunListItem racun={r} grupa={grupa} isLast={i == racuni.length - 1} index={i} fontWeight={oznaceniRacuniIDs.includes(r.RacunID) ? 700 : 400} onRacunClick={onRacunClick} backColor={oznaceniRacuniIDs.includes(r.RacunID) ? 'rgba(25, 118, 210, 0.08)' : 'white'} referenca={ref}></ERacunListItem>
                                })}
                            </List>
                        </Paper>
                    </Grid>
                ) : null}
                {grupa != null && racuni.length == 0 ? (
                    <Grid item xs={12}>
                        <Typography variant="subtitle1" gutterBottom component="div" style={{marginBottom:"15px", textAlign:"center"}}>
                            Ne postoji niti jedan račun prema zadanom filteru.
                        </Typography>
                    </Grid>
                ) : null}
                <Grid item xs={4} container justifyContent="flex-start">
                    <Button variant="outlined" startIcon={<LibraryAddCheckIcon></LibraryAddCheckIcon>} onClick={oznaciSve}>Označi sve</Button>
                    <Button variant="outlined" startIcon={<CheckBoxOutlineBlankIcon></CheckBoxOutlineBlankIcon>} onClick={ponistiOdabir} style={{marginLeft:"5px"}}>Poništi odabir</Button>
                </Grid>
                <Grid item xs={8} container justifyContent="flex-end">
                    {global.roles.includes("27") ? (
                        <Button variant="outlined" startIcon={<BugReportIcon></BugReportIcon>} disabled={oznaceniRacuniIDs.length != 1} onClick={testXML} style={{marginLeft:"5px"}}>Testiraj XML</Button>
                    ) : null}
                    {global.roles.includes("28") && (grupa == 1 || grupa == 2) ? (
                        <Button variant="outlined" startIcon={<DifferenceIcon></DifferenceIcon>} disabled={oznaceniRacuniIDs.length != 1} onClick={loadKopija} style={{marginLeft:"5px"}}>Pošalji kopiju</Button>
                    ) : null}
                    {grupa == 1 || grupa == 2 ? (
                        <Button variant="outlined" startIcon={<TocIcon></TocIcon>} disabled={oznaceniRacuniIDs.length != 1} onClick={pregledPlacanja} style={{marginLeft:"5px"}}>Pregled plaćanja</Button>
                    ) : null}
                    {grupa == 0 ? (
                        <Button variant="outlined" color="error" startIcon={<ReportIcon></ReportIcon>} disabled={oznaceniRacuniIDs.length != 1 || !(racuni.find(r => r.RacunID == oznaceniRacuniIDs[0])) || racuni.find(r => r.RacunID == oznaceniRacuniIDs[0]).StatusID != 7} onClick={eIzvjestavanje} style={{marginLeft:"5px"}}>e-Izvještavanje</Button>
                    ) : null}
                    {grupa == 0 ? (
                        <Button variant="outlined" color="success" startIcon={<AutoFixNormalIcon></AutoFixNormalIcon>} disabled={oznaceniRacuniIDs.length == 0 || (racuni.filter(r => oznaceniRacuniIDs.includes(r.RacunID) && (r.StatusID == 7 || r.StatusID == 8)).length != oznaceniRacuniIDs.length)} onClick={obrisiGresku} style={{marginLeft:"5px"}}>Obriši grešku</Button>
                    ) : null}
                    {grupa == 1 ? (
                        <Button variant="outlined" startIcon={<AutoModeIcon></AutoModeIcon>} disabled={oznaceniRacuniIDs.length == 0} onClick={azurirajStatuse} style={{marginLeft:"5px"}}>Ažuriraj statuse</Button>
                    ) : null}
                    {grupa == 1 || grupa == 2 ? (
                        <Button variant="outlined" color="success" startIcon={<CreditScoreIcon></CreditScoreIcon>} disabled={oznaceniRacuniIDs.length != 1} onClick={oznaciKaoPlacen} style={{marginLeft:"5px"}}>Označi kao plaćen</Button>
                    ) : null}
                    {grupa == 3 ? (
                        <Button variant="outlined" startIcon={<EditCalendarIcon></EditCalendarIcon>} disabled={oznaceniRacuniIDs.length == 0} onClick={zakaziSlanje} style={{marginLeft:"5px"}}>Promijeni vrijeme</Button>
                    ) : null}
                    {grupa == 3 ? (
                        <Button variant="contained" startIcon={<CancelIcon></CancelIcon>} disabled={oznaceniRacuniIDs.length == 0} onClick={ponistiSlanje} style={{marginLeft:"5px"}}>Poništi slanje</Button>
                    ) : null}
                    {grupa == 0 ? (
                        <Button variant="outlined" startIcon={<ScheduleSendIcon></ScheduleSendIcon>} disabled={oznaceniRacuniIDs.length == 0 || (racuni.filter(r => oznaceniRacuniIDs.includes(r.RacunID) && r.StatusID == null).length != oznaceniRacuniIDs.length)} onClick={zakaziSlanje} style={{marginLeft:"5px"}}>Zakaži slanje</Button>
                    ) : null}
                    {grupa == 0 ? (
                        <Button variant="contained" startIcon={<SendIcon></SendIcon>} disabled={oznaceniRacuniIDs.length == 0 || (racuni.filter(r => oznaceniRacuniIDs.includes(r.RacunID) && r.StatusID == null).length != oznaceniRacuniIDs.length)} onClick={posalji} style={{marginLeft:"5px"}}>Pošalji</Button>
                    ) : null}
                </Grid>

            </Grid>

            {/* {confirmMessage != null && confirmMessage != "" ? <AlertDialog title={confirmTitle} icon={<PriorityHighIcon style={{marginRight:"15px"}} color="danger"></PriorityHighIcon>} message={confirmMessage} cancelHidden={false} confirmHidden={false} okHidden={true} cancelLabel={"Zatvori"} cancelAction={closeConfirmWindow} confirmLabel={"Potvrdi"} confirmAction={onConfirm} confirmDisabled={!confirmAction}></AlertDialog> : null} */}

            <Modal open={confirmMessage != null}>
                <Box sx={modalStyle} overflow={"auto"} >
                    <Grid container spacing={1}>
                        <Grid item xs={12} container justifyContent="center">
                            <Typography variant="h6" gutterBottom component="div" style={{marginBottom:"15px"}}>
                                <PriorityHighIcon style={{marginRight:"15px"}} color="danger"></PriorityHighIcon>
                                {confirmTitle}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} style={{ fontSize: "14pt" }}>
                            {confirmMessage}
                        </Grid>
                        {confirmAction == "zakaziSlanje" ? 
                            <Grid item xs={12}>
                                <LocalizationProvider locale={hr} dateAdapter={AdapterDateFns}>
                                    <DateTimePicker onChange={v => setDatumSlanja(v)} label="Vrijeme slanja" value={datumSlanja} inputFormat="dd.MM.yyyy HH:mm" renderInput={(params) => <TextField {...params} style={{width:"100%"}} size="small" error={!datumSlanja || isNaN(new Date(datumSlanja))} />} /> 
                                </LocalizationProvider>
                            </Grid>
                        : null}
                        {confirmAction == "oznaciKaoPlacen" ? 
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField value={placeno} type="text" error={placeno == null || placeno == "" || isNaN(parseFloat(placeno))} onChange={handlePlacenoChange} onBlur={handlePlacenoFocusOut} label="Iznos" size="small" required></TextField>    
                                </FormControl>
                            </Grid>
                        : null}
                        {confirmAction == "oznaciKaoPlacen" ? 
                            <Grid item xs={12}>
                                <LocalizationProvider locale={hr} dateAdapter={AdapterDateFns}>
                                    <DatePicker onChange={v => setDatumPlacanja(v)} label="Datum plaćanja" value={datumPlacanja} inputFormat="dd.MM.yyyy" maxDate={new Date()} renderInput={(params) => <TextField {...params} style={{width:"100%"}} size="small" error={!datumPlacanja || isNaN(new Date(datumPlacanja))} />} /> 
                                </LocalizationProvider>
                            </Grid>
                        : null}
                        {confirmAction == "oznaciKaoPlacen" ? 
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <Autocomplete
                                        autoHighlight
                                        disableClearable
                                        options={naciniPlacanja}
                                        value={nacinPlacanja}
                                        getOptionLabel={(option) => option.Naziv}
                                        onChange={(e,v) => setNacinPlacanja(v)}
                                        renderInput={(params) => <TextField {...params} label="Način plaćanja" size="small" />}
                                    />
                                </FormControl>
                            </Grid>
                        : null}
                        {confirmAction == "posalji" || confirmAction == "zakaziSlanje" ? 
                            <Grid item xs={12}>
                                <FormControlLabel  
                                    labelPlacement="end" 
                                    label="Pošalji PDF vizualizaciju računa kao prilog"
                                    control={
                                        <Checkbox checked={posaljiPrilog} onChange={e => {
                                            setPosaljiPrilog(e.target.checked)
                                        }}></Checkbox>
                                    }
                                ></FormControlLabel>
                            </Grid>
                        : null}
                        {confirmAction == "posalji" || confirmAction == "zakaziSlanje" ? 
                            <Grid item xs={12}>
                                <FormControlLabel  
                                    labelPlacement="end" 
                                    label="Pošalji PDF vizualizacije specifikacija kao prilog (ako postoje)"
                                    control={
                                        <Checkbox checked={posaljiPrilogSpecifikaciju} onChange={e => {
                                            setPosaljiPrilogSpecifikaciju(e.target.checked)
                                        }}></Checkbox>
                                    }
                                ></FormControlLabel>
                            </Grid>
                        : null}
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" width="100%" marginTop="10px" >
                                <Button onClick={onConfirm} style={{marginRight:"10px"}} disabled={!confirmAction || (confirmAction == "zakaziSlanje" && (!datumSlanja || isNaN(new Date(datumSlanja)))) || (confirmAction == "oznaciKaoPlacen" && (placeno == null || placeno == "" || isNaN(parseFloat(placeno)))) || (confirmAction == "oznaciKaoPlacen" && (!datumPlacanja || isNaN(new Date(datumPlacanja))))} startIcon={<CheckIcon></CheckIcon>} variant="contained" >Potvrdi</Button>
                                <Button variant="outlined" startIcon={<ClearIcon></ClearIcon>} color="error" onClick={closeConfirmWindow} >Odustani</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            <Modal open={placanjaOpen}>
                <Box sx={{...modalStyle, width:"70vw"}} overflow={"auto"} >
                    <Grid container spacing={1}>
                        {oznaceniRacuniIDs != null && oznaceniRacuniIDs.length > 0 && racuni.find(r => r.RacunID == oznaceniRacuniIDs[0]) != null && placanja != null && placanja.length > 0 ? (
                            <>
                                <Grid item xs={12}>
                                    <ListItem className="list-title" key="racuni-title" style={{backgroundColor:"lightblue"}}>
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Tooltip title="Iznos" enterDelay={200} enterNextDelay={200}>
                                                    <ListItemText style={{ paddingLeft:"5px", textAlign:"right" }} primaryTypographyProps={{ noWrap:true }} primary="Iznos" />
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Tooltip title="Datum" enterDelay={200} enterNextDelay={200}>
                                                    <ListItemText style={{ paddingLeft:"5px", textAlign:"center" }} primaryTypographyProps={{ noWrap:true }} primary="Datum" />
                                                </Tooltip>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Tooltip title="Način plaćanja" enterDelay={200} enterNextDelay={200}>
                                                    <ListItemText style={{ paddingLeft:"5px" }} primaryTypographyProps={{ noWrap:true }} primary="Način plaćanja" />
                                                </Tooltip>
                                            </Grid>
                                        </Grid>
                                    </ListItem>
                                    <Paper variant="outlined" style={{width:"100%", maxHeight: 350, overflow: 'auto'}}>
                                        <List>
                                            {placanja.map((p,i) => {
                                                return (
                                                    <ListItem className={"list-item"} style={{ paddingTop: 0, paddingBottom: 0 }} >
                                                        <Grid container>    
                                                            <Grid item xs={4}>
                                                                <Tooltip title={(Math.round(p.PaidAmount * 100) / 100).toLocaleString("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} enterDelay={200} enterNextDelay={200}>
                                                                    <ListItemText style={{ paddingLeft:"5px", textAlign:"right" }} primaryTypographyProps={{ noWrap:true }} primary={ (Math.round(p.PaidAmount * 100) / 100).toLocaleString("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) } />
                                                                </Tooltip>
                                                            </Grid>  
                                                            <Grid item xs={4}>
                                                                <Tooltip title={dateFormat(p.DateOfPayment, "dd.mm.yyyy")} enterDelay={200} enterNextDelay={200}>
                                                                    <ListItemText style={{ paddingLeft:"5px", textAlign:"center" }} primaryTypographyProps={{ noWrap:true }} primary={ dateFormat(p.DateOfPayment, "dd.mm.yyyy") } />
                                                                </Tooltip>
                                                            </Grid>  
                                                            <Grid item xs={4}>
                                                                <Tooltip title={naciniPlacanja.find(np => np.FiskalniNacinPlacanja.ERacunKod == p.PaymentTypeCode).Naziv} enterDelay={200} enterNextDelay={200}>
                                                                    <ListItemText style={{ paddingLeft:"5px" }} primaryTypographyProps={{ noWrap:true }} primary={ naciniPlacanja.find(np => np.FiskalniNacinPlacanja.ERacunKod == p.PaymentTypeCode).Naziv } />
                                                                </Tooltip>
                                                            </Grid>
                                                        </Grid>
                                                    </ListItem>
                                            )})}
                                            <Divider component="li" />
                                            <ListItem className={"list-item"} >
                                                <Grid container>
                                                    <Grid item xs={2}>
                                                        <Typography variant="body1" gutterBottom component="div">
                                                            <b>UKUPNO PLAĆENO:</b>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography variant="body1" gutterBottom component="div" align="right">
                                                            <b>{((placanja.reduce((p1, p2) => { return p1 + p2.PaidAmount; }, 0) * 100) / 100).toLocaleString("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                            <Divider component="li" />
                                            <ListItem className={"list-item"} >
                                                <Grid container>
                                                    <Grid item xs={2}>
                                                        <Typography variant="body1" gutterBottom component="div">
                                                            <b>PREOSTALO:</b>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Typography variant="body1" gutterBottom component="div" align="right">
                                                            <b>{(((racuni.find(r => r.RacunID == oznaceniRacuniIDs[0]).Iznos - placanja.reduce((p1, p2) => { return p1 + p2.PaidAmount; }, 0)) * 100) / 100).toLocaleString("hr-HR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </ListItem>
                                        </List>
                                    </Paper>
                                </Grid>
                            </>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1" gutterBottom component="div">
                                    e-Račun još nije označen kao plaćen.
                                </Typography>
                            </Grid> 
                        )}
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" width="100%" marginTop="10px" >
                                <Button variant="outlined" startIcon={<ClearIcon></ClearIcon>} color="error" onClick={() => setPlacanjaOpen(false)}>Zatvori</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>



            <Modal open={kopijaOpen}>
                <Box sx={{...modalStyle, width:"70vw"}} overflow={"auto"} >
                    <Grid container spacing={1}>
                        <Grid item xs={12} container justifyContent="center">
                            <Typography variant="h6" gutterBottom component="div" style={{marginBottom:"15px"}}>
                                <DifferenceIcon style={{marginRight:"15px"}} color="danger"></DifferenceIcon>
                                Slanje kopije e-računa
                            </Typography>
                        </Grid>
                        <Grid item xs={12} container justifyContent="center" marginTop={5} marginBottom={5}>
                            <Alert severity="warning">
                                <b>UPOZORENJE!</b>
                                <br></br>
                                Klikom na gumb <i><b>Pošalji</b></i> e-račun će biti ponovno poslan klijentu, uz spremljene izmjene. Nakon pokretanja slanja isto više nije moguće poništiti.
                            </Alert>
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl fullWidth>
                                <TextField value={napomena} multiline rows={4} type="text" onChange={e => setNapomena(e.target.value)} label="Napomena" size="small" required></TextField>    
                            </FormControl>
                        </Grid>
                        <Grid item xs={poslovniProces && poslovniProces.ErPoslovniProcesID == 99 ? 8 : 12}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    autoHighlight
                                    disableClearable
                                    options={poslovniProcesi}
                                    value={poslovniProces}
                                    getOptionLabel={(option) => option.Kod + " - " + option.Opis}
                                    onChange={(e,v) => setPoslovniProces(v)}
                                    renderInput={(params) => <TextField {...params} label="Poslovni proces" size="small" />}
                                />
                            </FormControl>
                        </Grid>
                        {poslovniProces && poslovniProces.ErPoslovniProcesID == 99 &&
                            <Grid item xs={4}>
                                <FormControl fullWidth >
                                    <TextField label="Poslovni proces - oznaka kupca" value={poslovniProcesOznakaKupca} onChange={e => setPoslovniProcesOznakaKupca(e.target.value)} size="small" error={!poslovniProcesOznakaKupca}></TextField>
                                </FormControl>
                            </Grid>
                        }
                        {poslovniProces && poslovniProces.UgovorReferenca ? (
                            <Grid item xs={poslovniProces.NarudzbenicaReferenca ? 6 : 12}>
                                <FormControl fullWidth >
                                    <TextField label="Referenca ugovora" value={ugovorReferenca} onChange={e => setUgovorReferenca(e.target.value)} size="small"></TextField>
                                </FormControl>
                            </Grid>
                        ) : null}
                        {poslovniProces && poslovniProces.NarudzbenicaReferenca ? (
                            <Grid item xs={poslovniProces.UgovorReferenca ? 6 : 12}>
                                <FormControl fullWidth >
                                    <TextField label="Referenca narudžbenice" value={narudzbenicaReferenca} onChange={e => setNarudzbenicaReferenca(e.target.value)} size="small"></TextField>
                                </FormControl>
                            </Grid>
                        ) : null}
                        <Grid item xs={12}>
                            <Box display="flex" justifyContent="flex-end" width="100%" marginTop="10px" >
                                <Button variant="contained" startIcon={<SendIcon></SendIcon>} color="primary" disabled={!poslovniProces || (poslovniProces.ErPoslovniProcesID == 99 && !poslovniProcesOznakaKupca)} onClick={kopija}>Pošalji</Button>
                                <Button variant="outlined" style={{marginLeft:"5px"}} startIcon={<ClearIcon></ClearIcon>} color="error" onClick={closeKopija}>Odustani</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>

            {errorMessage != null && errorMessage != "" ? <AlertDialog title="Greška" icon={<ErrorIcon style={{marginRight:"15px", color:"red"}}></ErrorIcon>} message={errorMessage} cancelHidden={false} confirmHidden={true} okHidden={true} cancelLabel={"Zatvori"} cancelAction={closeErrorAlert}></AlertDialog> : null}
        </ComponentContainer>
    );
}